(function () {
  'use strict';

  var FLAG_KEY = 'myao_show_android_dialog';
  var TARGET_KEY = 'myao_entry_target_url';

  function getStorage() {
    try {
      return window.sessionStorage;
    } catch (error) {
      try {
        return window.localStorage;
      } catch (ignored) {
        return null;
      }
    }
  }

  function readFlag() {
    var storage = getStorage();
    if (!storage) return '';
    return storage.getItem(FLAG_KEY) || '';
  }

  function readTargetUrl(root) {
    var storage = getStorage();
    var fromStorage = storage ? (storage.getItem(TARGET_KEY) || '') : '';
    var fromMarkup = root ? (root.getAttribute('data-target-url') || '') : '';
    return (fromStorage && fromStorage.trim()) || (fromMarkup && fromMarkup.trim()) || window.location.href;
  }

  function clearFlag() {
    var storage = getStorage();
    if (!storage) return;
    storage.removeItem(FLAG_KEY);
    storage.removeItem(TARGET_KEY);
  }

  function isAndroid() {
    return /\bAndroid\b/i.test(navigator.userAgent || '');
  }

  function buildIntentUrl(url) {
    var parsed = new URL(url, window.location.href);
    var scheme = parsed.protocol.replace(':', '');
    return 'intent://' + parsed.host + parsed.pathname + parsed.search + parsed.hash + '#Intent;scheme=' + scheme + ';package=com.android.chrome;S.browser_fallback_url=' + encodeURIComponent(parsed.toString()) + ';end';
  }

  function tryOpenExternally(url) {
    if (!isAndroid() || !/^https?:/i.test(url)) {
      window.location.href = url;
      return;
    }

    var intentUrl;
    try {
      intentUrl = buildIntentUrl(url);
    } catch (error) {
      return;
    }

    var link = document.createElement('a');
    link.href = intentUrl;
    link.rel = 'noopener';
    link.style.display = 'none';
    document.body.appendChild(link);
    link.click();
    window.setTimeout(function () {
      if (link.parentNode) link.parentNode.removeChild(link);
    }, 0);
  }

  function init() {
    var root = document.querySelector('[data-myao-android-dialog]');
    if (!root) return;
    if (!isAndroid()) return;
    if (readFlag() !== '1') return;

    var targetUrl = readTargetUrl(root);

    function open() {
      root.hidden = false;
      root.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('myao-android-dialog-open');
      document.body.classList.add('myao-android-dialog-open');
    }

    function close() {
      root.hidden = true;
      root.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('myao-android-dialog-open');
      document.body.classList.remove('myao-android-dialog-open');
    }

    root.addEventListener('click', function (event) {
      if (event.target.closest('[data-myao-android-dialog-back]') || event.target.closest('[data-myao-android-dialog-close]')) {
        clearFlag();
        close();
        return;
      }

      if (event.target.closest('[data-myao-android-dialog-open]')) {
        clearFlag();
        close();
        tryOpenExternally(targetUrl);
      }
    });

    open();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
